import { Overview } from '../../dashboard/tutorial/overview/overview';
import { SectionSignUp } from '@/pages/public/home/section-sign-up';

export function HowItWorksPage() {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-1">
        <section className="w-full py-12 md:py-24 lg:py-24">
          <div className="container px-4 md:px-6 max-w-5xl mx-auto">
            <Overview />
          </div>
        </section>

        <SectionSignUp />
      </main>
    </div>
  );
}
